import { render, staticRenderFns } from "./spell.vue?vue&type=template&id=f4d0ec88&scoped=true&"
import script from "./spell.vue?vue&type=script&lang=js&"
export * from "./spell.vue?vue&type=script&lang=js&"
import style0 from "./spell.vue?vue&type=style&index=0&id=f4d0ec88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d0ec88",
  null
  
)

export default component.exports